/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import handleKeyPress from '../../../../../../../../common/handleKeyPress';
import imageSources from '../../../../../../../../constants/imageSources/imageSources';
import * as Styled from './styles';

class Option extends Component {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
        children: PropTypes.any,
        value: PropTypes.string,
        disabled: PropTypes.bool,
    };

    onClick = () => {
        const { disabled, onClick, value } = this.props;
        if (!disabled) {
            onClick(value);
        }
    };

    render() {
        const { children, disabled } = this.props;
        return (
            <Styled.DropDownOption
                data-tip
                onClick={this.onClick}
                onKeyDown={(e) => handleKeyPress(e, this.onClick)}
                disabled={disabled}
            >
                {children}
            </Styled.DropDownOption>
        );
    }
}
const DropDown = ({ toggleBlockType, ordered, unordered }) => (
    <Styled.DropDown>
        <Option value="unordered" onClick={toggleBlockType}>
            <Styled.ListImage src={unordered.icon} alt="Unordered List" />
            <Styled.BulletedList> Bulleted list </Styled.BulletedList>
        </Option>
        <Option value="ordered" onClick={toggleBlockType}>
            <Styled.ListImage src={ordered.icon} alt="Ordered List" />
            <Styled.NumberedList>Numbered list</Styled.NumberedList>
        </Option>
    </Styled.DropDown>
);

DropDown.propTypes = {
    toggleBlockType: PropTypes.func.isRequired,
    unordered: PropTypes.shape({
        title: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        className: PropTypes.string.isRequired,
    }),
    ordered: PropTypes.shape({
        title: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        className: PropTypes.string.isRequired,
    }),
};

const List = (props) => {
    const {
        config,
        currentState: { listType },
    } = props;
    const { unordered, ordered } = config;

    const [showDropDown, setShowDropDown] = useState(false);
    const toggleDropDown = () => {
        setShowDropDown(!showDropDown);
    };
    const toggleBlockType = (blockType) => {
        const { onChange } = props;
        onChange(blockType);
    };

    return (
        <>
            <Styled.ListButtonDiv onClick={toggleDropDown} onKeyDown={(e) => handleKeyPress(e, toggleDropDown)}>
                <Styled.ToolbarIcon data-tip data-for="list" src={imageSources.ICONS.LIST_BULLETED} alt="List" />
                {showDropDown && (
                    <DropDown
                        toggleBlockType={toggleBlockType}
                        listType={listType}
                        unordered={unordered}
                        ordered={ordered}
                    />
                )}
                <ReactTooltip id="list" place="top" effect="solid">
                    <Styled.MenuButtonIconTooltipText>List</Styled.MenuButtonIconTooltipText>
                </ReactTooltip>
            </Styled.ListButtonDiv>
        </>
    );
};

List.propTypes = {
    config: PropTypes.shape({
        component: PropTypes.func.isRequired,
        inDropdown: PropTypes.bool,
        options: PropTypes.arrayOf(PropTypes.string).isRequired,
        unordered: PropTypes.shape({
            title: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            className: PropTypes.string.isRequired,
        }),
        ordered: PropTypes.shape({
            title: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            className: PropTypes.string.isRequired,
        }),
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    currentState: PropTypes.shape({
        listType: PropTypes.string,
    }).isRequired,
};

export default List;
